import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { SettingsOption } from 'src/model/api/v2/data-contracts';

type Props = {
    id: string;
    label: string;
    hideLabel?: boolean;
    value: number;
    options: SettingsOption[];
    disabled?: boolean;
    onChange: (value: number) => void;
};

export const SettingsSelect = ({ id, label, hideLabel = false, value, options, disabled = false, onChange }: Props) => {
    const labelId = `${id}-label`;

    return (
        <FormControl fullWidth size="small" disabled={disabled}>
            {!hideLabel && <InputLabel id={labelId} shrink>{label}</InputLabel>}
            <Select
                labelId={hideLabel ? undefined : labelId}
                id={id}
                label={hideLabel ? undefined : label}
                notched={hideLabel ? undefined : true}
                inputProps={hideLabel ? { 'aria-label': label } : undefined}
                value={value}
                onChange={(event) => onChange(Number(event.target.value))}
            >
                {options.map((option) => (
                    <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
